import BrowserStorage from '@/scripts/helpers/browser-storage';
import stringHelper from '@/scripts/helpers/string-helper';
import userResponseProcessor, { UserInfoCompat } from './userResponseProcessor';

const storedKey = [
  'userId',
  'firstName',
  'lastName',
  'createdAt',
  'email',
  'profileImageUrl',
  'social',
  'fbId',
  'adminAccess',
];

const saveToStorage = function saveToStorage(this: any): void {
  // TODO: Legacy support. Data should not be retrieve from the local-storage
  Object
    .keys(this)
    .filter((key) => key !== 'adminAccess')
    .forEach((key) => {
      BrowserStorage.setItem(stringHelper.toSnakeCase(key), this[key]);
    })
  ;
};
const removeFromStorage = function removeFromStorage(this: string[]): void {
  this
    .filter((key) => key !== 'adminAccess')
    .forEach((key) => {
      BrowserStorage.removeItem(stringHelper.toSnakeCase(key));
    })
  ;
};

const getDct = <T>(value: T): PropertyDescriptor => ({
  enumerable: true,
  configurable: true,
  writable: false,
  value,
});

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface User extends UserInfoCompat {};
/**
 * A user object for the current logged in user
 */
class User {
  static getProcessedResponse(res: any): UserInfoCompat {
    return userResponseProcessor.getRemappedResponse(
      userResponseProcessor.getProcessedEmail(res),
    );
  }

  /**
   *
   * @param res response from /v2/me
   */
  constructor(res: any) {
    const properties = User.getProcessedResponse(res);
    Object
      .keys(properties)
      .forEach((key) => {
        Object.defineProperty(this, key, getDct((properties as any)[key]));
      })
    ;

    // Restore storage property for legacy support
    // Legacy support for component that depends on localStorage.user_id
    // eslint-disable-next-line @typescript-eslint/camelcase
    (res as any).user_id = res.id;
    // Store only keys defined in storedKey
    saveToStorage.call(
      storedKey.reduce((accumulator, property) => ({
        ...accumulator,
        [property]: (res as any)[stringHelper.toSnakeCase(property)],
      }), {}),
    );
  }

  destroy(): void {
    removeFromStorage.call(storedKey);
    Object.keys(this).forEach((key) => {
      delete (this as any)[key];
    });
  }
}
export default User;
